<template>
  <div>
    <!-- Main content -->
    <div v-if="user" class="md-layout md-gutter">
      <div class="md-layout-item md-size-100 md-small-size-100">
        <user-profile-card
            :user="user"
            :show-password-modal.sync="showPasswordModal"
        />
      </div>

<!--      <div class="md-layout-item md-size-100 md-small-size-100">-->
<!--        <div class="md-layout-item md-size-100">-->
<!--          <user-edit-card :user="user"/>-->
<!--        </div>-->
<!--        <div class="md-layout-item md-size-100">-->
<!--          <user-password-card :user="user"/>-->
<!--        </div>-->
<!--      </div>-->

      <!-- Admin sections -->
      <template v-if="roles.includes('admin')">
        <div class="md-layout-item md-size-100 md-small-size-100">
          <role-permissions-table
              :table-data="user.permissions"
              :role="user"
              @removePermission="deletePermissionRow"
              @addPermissionToRole="showPermissionModal"
          />
          <add-permission-modal
              :title="'Add Permission to '+user.name"
              :showModal="showPermissionForm"
              @closeModal="hidePermissionModal"
              @addPermissions="addPermissions"
          />
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100">
          <user-role-table
              :table-data="user.roles"
              :user="user"
              type="User"
              @removeRole="deleteRoleRow"
              @addRoleToUser="showRoleModal"
          />
          <add-role-modal
              :title="'Add Role to '+user.name"
              :showModal="showRoleForm"
              @closeModal="hideRoleModal"
              @addRoles="addRoles"
          />
        </div>
      </template>
    </div>

    <!-- Password Change Modal - ALWAYS outside the v-if -->
    <password-change-modal
        v-model="showPasswordModal"
        @success="onPasswordChanged"
    />
  </div>
</template>

<script>
import {
  AddPermissionModal,
  AddRoleModal
} from '@/components';
// import UserEditCard from '@/pages/Dashboard/Examples/UserProfile/EditProfileCard.vue';
// import UserPasswordCard from '@/pages/Dashboard/Examples/UserProfile/EditPasswordCard.vue';
import UserProfileCard from '@/pages/Dashboard/Examples/UserProfile/UserProfileCard.vue';
import UserRoleTable from '../../../components/Tables/UserRoleTable';
import RolePermissionsTable from '../../../components/Tables/RolePermissionsTable';
import PasswordChangeModal from "@/components/PasswordChangeModal.vue";

export default {
  name: 'user-profile-example',
  components: {
    PasswordChangeModal,
    RolePermissionsTable,
    AddPermissionModal,
    UserRoleTable,
    AddRoleModal,
    'user-profile-card': UserProfileCard
  },
  data() {
    return {
      showPasswordModal: false,
      user: null,
      showPermissionForm: false,
      showRoleForm: false,
      roleData: [],
      roles: [],
      allPermissions: []
    };
  },
  created() {
    this.getProfile();
  },
  methods: {
    async getProfile() {
      try {
        await this.$store.dispatch('profile/me');
        this.user = await this.$store.getters['profile/me'];

        const id = this.user.id;
        await this.$store.dispatch('permissions/list', id);
        this.permissions = this.$store.getters['permissions/list'];
      } catch (error) {
        console.error('Error fetching profile:', error);
        this.$store.dispatch('alerts/error', 'Failed to load profile');
      }
    },

    // ============ PASSWORD METHODS ============
    onPasswordChanged() {
      this.showPasswordModal = false;
      this.$store.dispatch('alerts/success', 'Password updated successfully');
      this.getProfile(); // Refresh user data
    },

    // ============ PERMISSION METHODS ============
    deletePermissionRow(item) {
      let indexToDelete = this.user.permissions.findIndex(
          tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.user.permissions.splice(indexToDelete, 1);
        this.update();
      }
    },

    showPermissionModal() {
      this.showPermissionForm = true;
    },

    hidePermissionModal() {
      this.showPermissionForm = false;
    },

    async addPermissions(new_permission) {
      try {
        let permissionIds = this.user.permissions.map(p => p.id);
        let updateNeeded = false;
        new_permission.forEach(permission => {
          if (!permissionIds.includes(permission.id)) {
            this.user.permissions.push(permission);
            updateNeeded = true;
          } else {
            this.$store.dispatch(
                'alerts/error',
                `Oops, Permission for ${permission.name} already on list!`
            );
          }
        });
        if (updateNeeded) {
          await this.update();
        }
        this.hidePermissionModal();
      } catch (e) {
        this.$store.dispatch('alerts/error', 'Oops, something went wrong!');
      }
    },

    // ============ ROLE METHODS ============
    deleteRoleRow(item) {
      let indexToDelete = this.user.roles.findIndex(
          tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.user.roles.splice(indexToDelete, 1);
        this.update();
      }
    },

    showRoleModal() {
      this.showRoleForm = true;
    },

    hideRoleModal() {
      this.showRoleForm = false;
    },

    async addRoles(new_role) {
      try {
        let roleIds = this.user.roles.map(p => p.id);
        let updateNeeded = false;
        new_role.forEach(role => {
          if (!roleIds.includes(role.id)) {
            this.user.roles.push(role);
            updateNeeded = true;
          } else {
            this.$store.dispatch(
                'alerts/error',
                `Oops, Role for ${role.name} already on list!`
            );
          }
        });
        if (updateNeeded) {
          await this.update();
        }
        this.hideRoleModal();
      } catch (e) {
        this.$store.dispatch('alerts/error', 'Oops, something went wrong!');
      }
    },

    // ============ UPDATE METHOD ============
    async update() {
      try {
        await this.$store.dispatch('users/update', this.user);
        await this.$store.dispatch('alerts/success', 'User updated successfully.');
      } catch (e) {
        if (e.response && e.response.data && e.response.data.errors && e.response.data.errors[0]) {
          await this.$store.dispatch('alerts/error', e.response.data.errors[0].title);
          this.setApiValidation(e.response.data.errors);
        } else {
          await this.$store.dispatch('alerts/error', 'Oops, something went wrong!');
        }
      }
    }
  },
  watch: {
    me: {
      handler: function(val) {
        if (val && val.roles) {
          this.roles = val.roles.map(r => r.name);
        }
        if (val && val.allPermissions) {
          this.allPermissions = val.allPermissions.map(p => p.name);
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style scoped>
.md-layout {
  padding: 16px;
}

.md-layout-item {
  margin-bottom: 16px;
}

@media (max-width: 768px) {
  .md-layout {
    padding: 8px;
  }
}
</style>